import { apiFetch } from '../api';
import type { EmailTemplates } from '@/pages/campaigns/new/lib/wizard-store';

export interface ContactFactice {
  firstName: string;
  lastName: string;
  companyName: string;
  services: string[];
  personas: string[];
  industry: string;
  website?: string;
}

export interface CampaignContext {
  sender: string;
  offer: string;
  target: string;
}

export interface EmailBlocksPreviewRequest {
  templates: EmailTemplates;
  contact_factice: ContactFactice;
  campaign_context: CampaignContext;
}

export interface EmailBlocksPreviewResponse {
  email01_subject: string;
  email01_body_rendered: string;
  email02_subject: string;
  email02_body_rendered: string;
  email03_subject: string;
  email03_body_rendered: string;
  generation_metadata: {
    tokens: number;
    cost: number;
    model: string;
  };
}

export function postEmailBlocksPreview(
  body: EmailBlocksPreviewRequest,
): Promise<EmailBlocksPreviewResponse> {
  return apiFetch('/v1/llm/email-blocks-preview', { method: 'POST', body });
}
